export default __webpack_public_path__ + "static/media/doc2.b687a553.png";